import { FilterTypesEnum } from '../models/FitlerTypesEnum';

export const PMR_STAGE_VALUES = [1, 2, 3];
export const PMR_RELATIONSHIP_VALUES = ['PMR_PARENT', 'PMR_CHILD'];

export enum PmrRelationshipSelection {
  All = 0,
  Parent = 1,
  Child = 2,
}

const getSelectedStages = (selectedStage = 0) =>
  selectedStage === 0 ? PMR_STAGE_VALUES : [selectedStage];

const getSelectedRelationships = (selectedRelationship = PmrRelationshipSelection.All) => {
  switch (selectedRelationship) {
    case PmrRelationshipSelection.Parent:
      return [PMR_RELATIONSHIP_VALUES[0]];
    case PmrRelationshipSelection.Child:
      return [PMR_RELATIONSHIP_VALUES[1]];
    default:
      return PMR_RELATIONSHIP_VALUES;
  }
};

export const getPmrStateDistributionFilters = (selectedStage = 0, selectedRelationship = 0) => [
  {
    filterType: FilterTypesEnum.NumberIn,
    field: 'Stage',
    value: getSelectedStages(selectedStage),
  },
  {
    filterType: FilterTypesEnum.ValueIn,
    field: 'Childparent',
    value: getSelectedRelationships(selectedRelationship),
  },
];
